import { escapeHTML } from './utils';
import { is_valid_mail } from './validation';

$(function() {
	// show the sidebar form - charge or manager
	$('body').on('click', '.show-hidden-form', function() {
		var form = $('#' + $(this).attr('data-holder'));

		form.find('input.field:not(.field-alt)').each(function(){
			$(this).val( $(this).attr('title') ).removeClass('field-error');
		});

		$(this).parent().hide();

		form.show();
		form.find('.field:not(.field-alt)').eq(0).focus();
		return false;
	});

	// show status log
	$('body').on('click', '.show-status-log', function() {
		$(this).toggleClass('show').hide();
	});


	// hide the sidebar form
	$('body').on('click', 'input[name=cancel_hidden_form]', function(){
		var p = $(this).parent().parent().parent();
		p.find('.hidden-form').hide();
		p.find('.show-hidden-form').parent().show();
	});


	// save existing user to project
	$('body').on('click', 'input[name=save_existing_user]', function(){
		var p = $(this).parent().parent();
		var form_holder = $(this).parents('.hidden-form');
		var buttons = form_holder.parent().find('.buttons');

		var new_user = p.find('select option:selected').html();
		var holder = $('#' + $(this).attr('data-holder'));
		holder.append('<span>, Loading...</span>');

		form_holder.hide();
		buttons.show();

		var form = $(this).closest('form');
		var cont = $(this).closest('.add-user');

		$.ajax({
			type: form.attr('method'),
			url: form.attr('action'),
			data: form.serializeArray(),
			success: function(response) {
				var box = $(cont).closest('.sidebar-box');
				box.html($(response).find('#' + box.attr('id') + ' > *'));
			}
		})

		return false;
	});


	// save new status to project
	$('body').on('click', 'input[name=save_status]', function(){
		var form = $(this).closest('form');
		var form_holder = $(this).parents('.hidden-form');
		var status_holder = form_holder.parent().children('.status-holder');
		var status = status_holder.find('.status');
		var selected_status = form_holder.find('select option:selected');

		$.ajax({
			type: form.attr('method'),
			url: form.attr('action'),
			data: form.serializeArray(),
			success: function(response) {
				status.text( $.trim( selected_status.html() ) );
				form_holder.hide();
				status_holder.show();
			},
			error: function() {
				alert('Something went wrong.');
			}
		})

		return false;
	});


	// add new user (not existing) to project
	$('body').on('submit', '#add-new-coworker-form', function() {
		//return true;
		var name = $(this).find('#user_name');
		var mail = $(this).find('#user_mail');
		if (name.val()==name.attr('title')) {
			alert("Please enter co-worker name");
			name.focus();
			return false;
		}
		if ( !is_valid_mail(mail.val()) ) {
			alert("Please enter valid e-mail address");
			mail.focus();
			return false;
		}
		var data = $(this).serializeArray();
		var url = $(this).attr('action');

		var cont = $(this).closest('.sidebar-box');
 		$(this).html('Loading...');
		$.ajax({
			type: "POST",
			url: url,
			data: data,
			success: function(response) {
				cont.html($(response).find('#' + cont.attr('id') + ' > *'));
			}
		});

		return false;
	});


	// remove user from project
	$('body').on('click', '.remove-user-from-project', function() {
		var container = $(this).closest('p');
		var associated_users = container.find('span.involved-user');
		var user_name = $(this).parent().find('.involved-user').text();

		if (associated_users.length==1) {
			alert("At least one person should remain involved in this project. Please add other users in order to remove this one. ");
			return false;
		}
		var confirm_message = "Are you sure you want to remove " + user_name + "?";
		if (!window.confirm(confirm_message)) {
			return false;
		}
		var cont = $(this).closest('.sidebar-box');

		$(this).parent().html('Loading...');

		$.ajax({
			url: $(this).attr('href'),
			type: "POST",
			data: {
				user_id: $(this).attr('data-user')
			},
			success: function(response) {
				if( response == 'user_removed_himself' ) {
					window.location.href = '/projects';
				} else {
					cont.html( $(response).find('#' + cont.attr('id') + ' > *') );
				}
			}
		});
		return false;
	});

	// remove main manager from porject
	$('body').on('click', '.remove-main-manager-from-project', function() {
		var message = $(this).data('alert');

		if (message) {
			window.alert(message);
		}

		return false;
	});

	$('body').on('click', '.change-project-owner', function() {
		var user_id = $(this).data('user-id')
		var cont = $(this).closest('.sidebar-box');

		$.ajax({
			url: $(this).attr('href'),
			type: "POST",
			data: {
				user_id: user_id
			},
			success: function(response) {
				cont.html( $(response).find('#' + cont.attr('id') + ' > *') );
				window.location = window.location;
			},
			error: function() {
				alert('Something went wrong. ');
			}
		});
		return false;
	});

	// cancel add user form
	$('body').on('click', '.hidden-form input[name=cancel]', function() {
		var form = $(this).closest('form');
		var holder = $(this).closest('.hidden-form').parent();
		form.get(0).reset();
		form.parent().hide();
		holder.find('.buttons').show();
	});


	$('input[type=submit].archive, input[type=submit].activate, button[type=submit].archive, button[type=submit].activate ').click(function(){
		var checks = $('.projects input[type=checkbox]:checked');
		if( checks.length == 0 ) {
			alert('Please select at least one project.');
			return false;
		}
		return true;
	});

	// remove this
	$('#archive-btn, #archive-btn2').click(function() {
		window.location = $(this).attr('data-url');
	});

	$('.snooze-project-select').change(function() {
		window.location = $(this).val();
	});

	// update source files
	$(document).on('submit', 'form.ajaxified', function() {
		var form = $(this),
			url = form.attr('action'),
			type = form.attr('method'),
			data = form.serializeArray();

		form.trigger('pre_ajax_request');

		$.ajax({
			type: type,
			url: url,
			data: data,
			success: function(response) {
				form.trigger('ajax_request_completed', [response]);
			},
			error: function () {
				alert("Something went wrong. Please try again later. ");
			}
		});
		return false;
	});

	// source files
	$('#source-files-update')
	.bind('pre_ajax_request', function() {
		$(this).find('#source_files').val('Loading...');
	})
	.bind('ajax_request_completed', function(event, ajax_response) {
		var $sourceFiles = $(this).find('#source_files');

		$sourceFiles.val(ajax_response);
		$sourceFiles.attr('title', ajax_response);
		return false;
	});

	// html 5 upload for comments
	const token = window?.$$project_token ?? '';
	$('#comment-form').html5_upload({ file_uploads_url: `/handle-js-file-uploads/${token}` });

	var profilepopupInterval;
	$('.sidebar-box').delegate('.user-container', 'mouseenter', function() {
		var $userContainer = $(this);
		profilepopupInterval = setTimeout(function () {
			var userData = $userContainer.data();
			var lastSeenFormatted = userData.lastSeen && (new Date(userData.lastSeen)).format();
			var lastSeenAgo = userData.lastSeen && (new Date(userData.lastSeen)).relative();

			var tmplContext = {
				id: userData.id,
				isAdmin: userData.isAdmin,
				isProjectOwner: userData.isProjectOwner,
				isMainManager: userData.isMainManager,
				avatar: userData.bigAvatar,
				name: escapeHTML(userData.displayName),
				localTime: userData.localTime,
				timezone: escapeHTML(userData.timezone),
				companyName: escapeHTML(userData.company),
				companyUrl: escapeHTML(userData.companyUrl),
				mail: userData.contactMail,
				displayMail: userData.contactMail,
				createNoteUrl: userData.createNoteUrl,
				currentUserId: userData.currentUserId,
				lastSeen: lastSeenFormatted,
				lastSeenAgo: lastSeenAgo,
				canBeRemoved: userData.canBeRemoved,
				fastQuotesCount: userData.fastQuotesCount,
				slowQuotesCount: userData.slowQuotesCount,
				fastQuotesPercentage: userData.fastQuotesPercentage,
				slowQuotesPercentage: userData.slowQuotesPercentage,
				ipAddress: userData.ipAddress,
				ipCountryCode: userData.ipCountryCode,
				ipCountryName: userData.ipCountryName,
				ipCity: userData.ipCity,
			};

			var $profilePopup = $(tmpl($('#profile-popup-template').html(), tmplContext));
			$userContainer.append($profilePopup);

			var profilePopupWidth = $profilePopup.offset().left + $profilePopup.outerWidth(false);

			if (profilePopupWidth > $(window).width()) {
				$profilePopup.addClass('left-directed');
			}

			$userContainer.one('mouseleave', function() {
				$('.profile-popup', $userContainer).remove();
			})
		}, 200);
	});
	$('.sidebar-box').delegate('.user-container', 'mouseleave', function() {
		clearInterval(profilepopupInterval);
	});

	var statuspopupInterval;
	$('.sidebar-box-small').delegate('.update-status-log', 'mouseenter', function() {
		var $statusLogContainer = $(this);
		statuspopupInterval = setTimeout(function () {
			var $profilePopup = $(tmpl($('#status-popup-template').html(), {}));
			$statusLogContainer.append($profilePopup);

			var profilePopupWidth = $profilePopup.offset().left + $profilePopup.outerWidth(false);

			if (profilePopupWidth > $(window).width()) {
				$profilePopup.addClass('left-directed');
			}

			$statusLogContainer.one('mouseleave', function() {
				$('.profile-popup', $statusLogContainer).remove();
			})
		}, 200);
	});
	$('.sidebar-box-small').delegate('.update-status-log', 'mouseleave', function() {
		clearInterval(statuspopupInterval);
	});

	$('.sidebar-box-small').on('click', '.update-status-log', function(event) {
		event.preventDefault();
	});


	// Handles comments and project starring
	$('body').on('click', 'a.follow-ctrl', function() {
		var url = $(this).attr('href');
		var anchor = $(this);
		$.ajax({
			url: url,
			type: 'GET',
			success: function(r){
				anchor.toggleClass('is-following');
			}
		});
		return false;
	});

	$(document).on('click', '.toggle-charges', function(event) {
		event.preventDefault();
        $('body').addClass('billing__paid-charges-visible');
	});

	// Toggle expired quotes entries
	var $listQuotes = $('.list-quotes');

	$('.toggle-quotes').on('click', function(event) {
		event.preventDefault();

		$(this).hide();
		$listQuotes.addClass('is-expanded');
	});
});
